import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo, {
  duration: 800,
  easing: 'ease-in-out'
})

Vue.config.productionTip = false

// 親子関係のないコンポーネント間で関数を受け渡しするための設定
var eventHub = new Vue()
export default eventHub

new Vue({
  router,
  render: h => h(App),
  data: function() {
    return {
      title: 'Advision Co.,Ltd.'
    }
  },
  mounted() {
    if (this.$route.meta.title) {
      document.title = this.$route.meta.title + ' | ' + this.title
    } else {
      document.title = this.title
    }
  },
  methods: {
    createPageTitle : function(to){
      // タイトルを設定
      if(to.meta.title){
        document.title = to.meta.title + ' | ' + this.title;
      } else {
        document.title = this.title;
      }
    }
  },
  watch: {
    '$route' (to) {
      this.createPageTitle(to);
      if (to.name == 'home') {
        eventHub.$emit('setFooterH')
      }
      if (to.name != 'works') {
        // works以外のページに移動した時は常にページ最上部へ移動
        window.scrollTo(0, 0)
      }
      eventHub.$emit('closeMenu')
    }
  }
}).$mount('#app')

require('@/assets/scss/common.scss')
